import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import propTypes from 'prop-types';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const LineChart = ({chartLabels, chartData, ...rest})=> {

const options = {
  responsive: true,
  scales: {
    y: {
      title: {
        display: true,
        text: rest.yAxisLabel,
        font: value=>{
          var width = value.chart.width;
          var size = Math.round(width / 50);
           return {
             size: size
          };
        }
      },
      min: rest.yAxisMin,
      max: rest.yAxisMax,
      ticks: {
        callback: value =>{
          return value + "%"
        },
        font: value=>{
          var width = value.chart.width;
          var size = Math.round(width / 50);
           return {
             size: size
          };
        },
        stepSize: rest.yAxisIncrement 
      }    
    },
    x: {
      title: {
        display: true,
        text: rest.xAxisLabel,
        font: value=>{
          var width = value.chart.width;
          var size = Math.round(width / 50);
           return {
             size: size
          };
        }
      },
      ticks: {
        maxRotation: 0,
        minRotation: 0,
        font: value=>{
          var width = value.chart.width;
          var size = Math.round(width / 50);
           return {
             size: size
          };
        },
      }
    }
  },
  plugins: {
    title: {
      display: false,
      text: rest.title
    },
    tooltip: {
      enabled: true,
      callbacks: {
        label: (item) => rest.isPercent ? `${item.formattedValue}%` : `${item.formattedValue}` 
      }
    }
  }
};

const data = {
  labels: chartLabels,
  datasets: [
    {
      label: rest.title,
      data: chartData,
      borderColor: rest.borderColor,
      backgroundColor: rest.backgroundColor,
    },
  ],
};

  return (
    <div className="desktop:display-block mobile:display-none">
      <Line options={options} data={data} aria-label={`${rest.title}.`} />
    </div>
  );
}
export default LineChart;
LineChart.propTypes = { 
  title: propTypes.string,
  chartLabels: propTypes.array,
  chartData: propTypes.array,
  xAxisLabel: propTypes.string,
  yAxisLabel: propTypes.string,
  backgroundColor: propTypes.string,
  borderColor: propTypes.string,
  yAxisMax: propTypes.number,
  yAxisMin: propTypes.number,
  incrementValue: propTypes.number,
  isPercent: propTypes.bool
}
LineChart.defaultProps = {
  title: "",
  chartLabels: [],
  chartData: [],
  xAxisLabel: "",
  yAxisLabel: "",
  backgroundColor: '#383E56',
  borderColor: '#383E56',
  yAxisMax: 40,
  yAxisMin: 0,
  yAxisIncrement: 5,
  isPercent: false
}